<template>
  <div class="brand-collapse">
    <YorkbbsSkeleton class="brand-skeleton" :count="16" :loading="brand.loading">
      <div slot="template" class="barnd-skeleton__item">
        <el-skeleton-item variant="image"></el-skeleton-item>
        <el-skeleton-item variant="p"></el-skeleton-item>
      </div>
    </YorkbbsSkeleton>

    <div class="brand-list" v-show="!brand.loading">
      <router-link class="brand-item" :to="{ name: $route.name }" :class="{ 'is-checked': !$route.params.brand }">
        <img class="brand-logo" :src="require('@/assets/images/car/icon_all.png')" alt="全部" />
        <div class="brand-name">全部</div>
      </router-link>
      <router-link
        class="brand-item"
        v-for="(item, i) in brand.list.slice(0, firsetLineNumber)"
        :key="i"
        :to="{ params: { ...$route.params, brand: item.name }, query: { ...$route.query, offset: undefined } }"
        :class="{ 'is-checked': $route.params.brand == item.name }"
      >
        <img class="brand-logo" :src="item.logoUrl" :alt="item.nameCN" />
        <div class="brand-name">{{ item.nameCN }}</div>
      </router-link>
      <el-button class="brand-item" v-show="isCollapse" @click="isCollapse = false">
        <img class="brand-logo" :src="require('@/assets/images/car/icon_up.png')" alt="收起" />
        <div class="brand-name">收起</div>
      </el-button>
      <el-button class="brand-item" v-show="!isCollapse" @click="isCollapse = true">
        <img class="brand-logo" :src="require('@/assets/images/car/icon_down.png')" alt="展开" />
        <div class="brand-name">更多</div>
      </el-button>
    </div>
    <el-collapse-transition>
      <div class="brand-list more" v-show="isCollapse">
        <router-link
          class="brand-item"
          v-for="(item, i) in brand.list.slice(firsetLineNumber)"
          :key="i"
          :to="{ params: { ...$route.params, brand: item.name }, query: { ...$route.query, offset: undefined } }"
          :class="{ 'is-checked': $route.params.brand == item.name }"
        >
          <img class="brand-logo" :src="item.logoUrl" :alt="item.nameCN" />
          <div class="brand-name">{{ item.nameCN }}</div>
        </router-link>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import YorkbbsSkeleton from '@/common/skeleton.vue';
import {setHtmlMeta} from '@/utils/utils'
export default {
  name: 'CollapseBrand',
  components: { YorkbbsSkeleton },
  data() {
    return {
      // 品牌列表
      brand: {
        loading: false,
        list: [],
      },
      // 是否展开
      isCollapse: false,
      // 选中的索引
      checkedIndex: 0,

      // 第一行显示的数量
      firsetLineNumber: 14,
    };
  },
  computed: {
    // 选中的值
    checkedVal() {
      if (this.checkedIndex === 0) return {};
      return this.brand.list[this.checkedIndex - 1];
    },
  },
  created() {
    this.getBrands();
  },
  methods: {
    /**
     * 获取品牌列表
     */
    async getBrands() {
      this.brand.loading = true;
      const { data } = await this.$axios
        .post('/car/v1/get/brand/list', {
          list: 1,
          sortField: 'sort',
          sortType: 'ASC',
        })
        .finally(() => {
          this.brand.loading = false;
        });

      const index = data.list.findIndex(item => item.name == this.$route.params.brand);
      if (index >= this.firsetLineNumber) {
        this.isCollapse = true;
      }

      this.brand.list = data.list;

      const brand = data.list.find(item => item.name == this.$route.params.brand);
      this.$emit('change', brand);

      console.log('brand--------->',brand);
      if( brand ){
        const brandMergeStr = brand.nameCN + brand.name;
        let topicStr  = '';
        let routeName = this.$route.name;
        console.log('routeName------->',this.$route)
        if( routeName == 'ListUsed' ){
          topicStr = '二手车';
          setHtmlMeta({
            title:`${brandMergeStr} - 多伦多${topicStr} - 多伦多汽车 - 约克论坛`,
            keywords:`${brandMergeStr},多伦多二手${brandMergeStr}车,二手${brandMergeStr}转让,求购${brandMergeStr}二手车,多伦多留学生买二手车,回国卖车`,
            description:`多伦多华人和认证车行的二手${brandMergeStr}车源，信息真实，多伦多华人和留学生买卖二手车首选。`
          })
        }else if ( routeName == 'ListLease' ){
          topicStr = '转Lease';
          setHtmlMeta({
            title:`${brandMergeStr} - 多伦多${topicStr} - 多伦多汽车 - 约克论坛`,
            keywords:`${brandMergeStr}lease,多伦多${brandMergeStr}转lease,求lease${brandMergeStr},,多伦多留学生转lease,多伦多留学生接lease`,
            description:`${brandMergeStr}转lease。约克论坛汽车，最新最全的汽车信息交易平台。yorkbbs.ca`
          })
        } 
        /* 
{品牌},多伦多二手{品牌}车,二手{品牌}转让,求购{品牌}二手车,多伦多留学生买二手车,回国卖车
{品牌}lease,多伦多{品牌}转lease,求lease{品牌},,多伦多留学生转lease,多伦多留学生接lease */
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.brand-collapse {
  display: block;
  margin-bottom: 30px;
}
.brand-list {
  display: flex;
  flex-wrap: wrap;
  &.more {
    margin-top: 20px;
  }
}
.brand-item {
  width: calc(100% / 16);
  text-align: center;
  cursor: pointer;
  user-select: none;
  margin-right: 0;
  border-radius: 4px;
  &:hover {
    background-color: #f8f8f8;
  }
  & + .brand-item {
    margin-left: 0;
  }
  &.el-button {
    background-color: #fff;
    border: 0 none;
    padding: 0;
  }
  &:hover,
  &.is-checked {
    .brand-name {
      color: var(--primary-color);
    }
  }
}
.brand-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.brand-name {
  font-size: 14px;
  line-height: 22px;
  color: var(--text-color);
  padding: 5px 0;
}

.brand-skeleton {
  .barnd-skeleton__item {
    width: calc(100% / 16);
  }
  ::v-deep {
    .el-skeleton {
      display: flex;
      text-align: center;
    }
    .el-skeleton__image {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin: auto;
    }
    .el-skeleton__p {
      margin-top: 13px;
      &:nth-of-type(1) {
        width: 80%;
      }
      &:nth-child(2) {
        width: 60%;
      }
      &:nth-child(3) {
        width: 40%;
      }
    }
  }
}
</style>
